import { EditorContent } from '@tiptap/react';
import styled from 'styled-components';

export const StyledEditorContainer = styled.div({
  position: (props) => (props.$isFullScreen ? 'fixed' : ''),
  top: (props) => (props.$isFullScreen ? '0px' : ''),
  left: (props) => (props.$isFullScreen ? '0px' : ''),
  width: (props) => (props.$isFullScreen ? '100vw' : ''),
  height: (props) => (props.$isFullScreen ? '100vh' : ''),
  backgroundColor: (props) =>
    props.$isFullScreen ? 'var(--ds-bg-secondary)' : '',
  zIndex: (props) => (props.$isFullScreen ? '9999' : ''),
  display: (props) => (props.$isFullScreen ? 'flex' : ''),
  flexDirection: (props) => (props.$isFullScreen ? 'column' : ''),
  overflow: (props) => (props.$isFullScreen ? 'auto' : ''),
  alignItems: 'center',
  flex: 1,
  minHeight: (props) => (props.$isFullScreen ? '100vh' : '220px'),
});

export const StyledEditorContent = styled(EditorContent)({
  maxWidth: '1024px',
  width: 'calc(100% - 10px)',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  backgroundColor: 'var(--ds-bg-base)',
  bottom: (props) => (props.$isFullScreen ? 0 : ''),
  paddingLeft: '8px',
  paddingRight: '8px',
  border: (props) =>
    props.$isFullScreen ? '1px solid var(--ds-border-base)' : '',
  '& .ProseMirror': {
    marginTop: '10px',
    minHeight: (props) =>
      props.$isFullScreen ? 'calc(100% - 100px)' : '200px',
    height: '100%',
    padding: '10px',
    border: '1px solid var(--ds-border-base)',
    borderRadius: '4px',
  },
});

export const LinkDialogOverlay = styled.div({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: 'var(--ds-bg-base)',
  padding: '20px',
  paddingTop: '10px',
  borderRadius: '5px',
  boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
  zIndex: 1000,
  minWidth: '300px',
  display: 'flex',
  flexDirection: 'column',
  gap: '0',
});

export const LinkDialogTitle = styled.div({
  margin: '0 0 15px 0',
  fontFamily: 'proxima-nova',
  fontSize: '18px',
  fontWeight: '550',
  color: 'var(--ds-text-title)',
});

export const LinkDialogFieldContainer = styled.div({
  marginBottom: (props) => props.$marginBottom || '20px',
});

export const LinkDialogLabel = styled.label({
  display: 'block',
  marginBottom: '5px',
  fontSize: '14px',
});

export const LinkDialogInput = styled.input({
  width: '100%',
  padding: '8px',
  border: '1px solid var(--ds-border-base)',
  borderRadius: '4px',
  boxSizing: 'border-box',
});

export const LinkDialogButtonContainer = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '10px',
  marginTop: '50px',
});

export const LinkDialogCancelButton = styled.button({
  padding: '8px 12px',
  border: '1px solid var(--ds-border-base)',
  borderRadius: '4px',
  backgroundColor: 'transparent',
  cursor: 'pointer',
});

export const LinkDialogSaveButton = styled.button({
  padding: '8px 12px',
  backgroundColor: 'var(--ds-base)',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
});
